let Hooks = {}

Hooks.Changelog = {
    mounted() {
        this.el.addEventListener("click", (event) => {
            const button = event.target.closest('.more');
            const changelog = button && button.closest('.changelog');
            if (button && changelog) changelog.classList.add('is-open');
        });
    }
}

export {Hooks}